import React from 'react';
import { WrapKpk } from './styled';
import useUserData from 'hooks/useUserData';
import Underachievement from './components/Underachievement';
import ReadingLiteracy from './components/ReadingLiteracy';

const Kpk = () => {
  const userData = useUserData();
  const id = userData?.id || 0;
  
  return (
    <WrapKpk>
      <Underachievement id={id}/>
      <ReadingLiteracy id={id}/>
    </WrapKpk>
  );
};

export default Kpk;
